<template>
    <div id="app">
        <Header
            :routes="returnRoutesBasedOnType"
            :profileRoutes="returnProfileRoutesBasedOnType"
            name="account"
        />

        <div class="content">
            <OverlayLoader :isLoading="!userLoaded">
                <main class="page page-dashboard">
                    <div class="container">
                        <PageHeader
                            :title="$translate.text('auth.my_account')"
                        />

                        <form @submit.prevent="submitForm" method="POST">
                            <TextInput
                                id="firstName"
                                :value="user.first_name"
                                name="contactName"
                                @change="user.first_name = $event"
                                :label="$translate.text('general.contact.firstname')"
                            />

                            <TextInput
                                id="middleName"
                                :value="user.middle_name"
                                name="contactName"
                                @change="user.middle_name = $event"
                                :label="$translate.text('general.contact.middlename')"
                            />

                            <TextInput
                                id="lastName"
                                :value="user.last_name"
                                name="lastName"
                                @change="user.last_name = $event"
                                :label="$translate.text('general.contact.lastname')"
                            />

                            <EmailInput
                                id="email"
                                :value="user.email"
                                name="email"
                                @change="user.email = $event"
                                :label="$translate.text('general.email')"
                            />

                            <PasswordInput
                                id="password"
                                :value="user.password"
                                name="password"
                                @change="user.password = $event"
                                :label="$translate.text('general.password')"
                            />

                            <PasswordInput
                                id="passwordRepeat"
                                :value="user.password_confirmation"
                                name="passwordRepeat"
                                @change="user.password_confirmation = $event"
                                :label="$translate.text('general.password_confirm')"
                            />

<!--                            <Select-->
<!--                                id="language"-->
<!--                                :value="user.language"-->
<!--                                name="language"-->
<!--                                @change="user.language = $event"-->
<!--                                :options="languageOptions"-->
<!--                                :label="$translate.text('locales.preferred_language')"-->
<!--                            />-->

                            <FormSubmit
                                :buttonLabel="submittingIsLoading ? $translate.text('general.save_changes.saving') :  $translate.text('general.save_changes')"
                                :disabled="submittingIsLoading"
                            />

                            <div style="display: flex; align-items: center; margin-top: 20px;">
                                <label style="flex: 2;">&nbsp;</label>
                                <a @click='showRemoveAccountMessage' style='flex: 6; color: red;'>{{ $translate.text('general.account.delete') }}</a>
                            </div>

                        </form>
                    </div>
                </main>
            </OverlayLoader>
        </div>

        <Footer
            :routes="[
                { name: 'General About Us', label: $translate.text('nav.footer.about') },
                { name: 'General Conditions', label: $translate.text('nav.footer.conditions') },
                { name: 'General faq', label: $translate.text('nav.footer.help') },
                { name: 'General Contact Us', label: $translate.text('nav.footer.contact') }
            ]"
            name="account"
            :showLoggedIn="true"
        />
    </div>
</template>
<script>
import swal from 'sweetalert';
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import PageHeader from '@/components/PageHeader/PageHeader';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import TextInput from '@/components/Inputs/TextInput';
import PasswordInput from '@/components/Inputs/PasswordInput';
import EmailInput from '@/components/Inputs/EmailInput';
import FormSubmit from '@/components/Forms/FormSubmit';
import Select from '@/components/Inputs/Select';

import { get, put } from '@/helpers/http';
import handleError from '@/helpers/error';
import { getUserType } from '@/helpers/auth';

export default {
    name: 'Resellers',

    components: {
        Header,
        Footer,
        PageHeader,
        OverlayLoader,
        TextInput,
        EmailInput,
        FormSubmit,
        PasswordInput,
        // Select,
    },

    data() {
        return {
            user: {},
            userLoaded: false,
            submittingIsLoading: false,
            languageOptions: [
                { label: this.$translate.text('locales.dutch'), value: 'nl_NL' },
                { label: this.$translate.text('locales.english'), value: 'en_EN' },
                { label: this.$translate.text('locales.german'), value: 'de_DE' },
            ],
        };
    },

    created() {
        this.getUser();
    },

    methods: {
        getUser() {
            get({
                url: `${this.$API_URL}/api/auth/me`,
            })
                .then((response) => {
                    this.user = response.data.data;
                    this.user.password = '';
                    this.user.password_confirmation = '';
                    this.userLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            this.submittingIsLoading = true;

            if (this.user.password !== this.user.password_confirmation) {
                this.submittingIsLoading = false;
                this.user.password = '';
                this.user.password_confirmation = '';
                return swal(this.$translate.text('alert.whoops.message.password_mismatch'));
            }

            put({
                url: `${this.$API_URL}/api/auth/${this.user.id}`,
                data: {
                    first_name: this.user.first_name,
                    middle_name: this.user.middle_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                    password: this.user.password,
                    language: this.user.language,
                },
            })
                .then(() => {
                    this.$translate.setLang(this.user.language);
                    this.getUser();
                    this.submittingIsLoading = false;
                    swal({
                        title: this.$translate.text('alert.success'),
                        text: this.$translate.text('alert.success.message.saved'),
                    });
                })
                .catch((error) => {
                    this.submittingIsLoading = false;

                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        showRemoveAccountMessage() {
            swal({
                title: this.$translate.text('alert.remove_account.title'),
                text: this.$translate.text('alert.remove_account.text'),
            });
        },
    },

    computed: {
        returnRoutesBasedOnType() {
            const userType = getUserType();

            if (userType === 'reseller') return [{ name: 'Resellers Dashboard', label: this.$translate.text('general.dashboard') }, { name: 'Resellers Profiles', label: this.$translate.text('general.profiles') }];
            if (userType === 'admin') return [{ name: 'Admin Resellers', label: this.$translate.text('general.dashboard') }, { name: 'Admin Profiles', label: this.$translate.text('general.profiles') }];
            if (userType === 'client') return [{ name: 'Clients Dashboard', label: this.$translate.text('general.dashboard') }, { name: 'Clients Webshops', label: this.$translate.text('general.webshops') }, { name: 'Clients Feeds', label: this.$translate.text('general.feeds') }, { name: 'Clients Connections', label: this.$translate.text('general.connections') }];
            return [];
        },

        returnProfileRoutesBasedOnType() {
            const userType = getUserType();
            if (userType === 'reseller') return [{ name: 'Account', label: this.$translate.text('auth.my_account') }, { name: 'Resellers Summary', label: this.$translate.text('resellers.summary') }, { name: 'Logout', label: this.$translate.text('auth.logout') }];
            if (userType === 'admin') return [{ name: 'Account', label: this.$translate.text('auth.my_account') }, { name: 'Logout', label: this.$translate.text('auth.logout') }];
            if (userType === 'client') return [{ name: 'Account', label: this.$translate.text('auth.my_account') }, { name: 'Client Company', label: this.$translate.text('clients.company') }, { name: 'Logout', label: this.$translate.text('auth.logout') }];
            return [];
        },
    },
};
</script>
<style lang="scss" scoped>
    .content {
        min-height: 100%;
        margin-bottom: -50px;
    }
</style>
